const couriersCodeToNameList = {
  APF: 'AlphaFast',
  ARM: 'Aramex',
  BEE: 'BEEExpress',
  BMD: 'BmDelivery',
  CJE: 'CJ Express',
  CJL: 'CJ Logistics',
  CJLX: 'CJLogisticShopX',
  DHL: 'DHL eCommerce',
  FLE: 'FlashExpress',
  JNTP: 'JAndTExpress Pickup',
  JNTPF: 'JAndTExpress PickUp Free',
  JNTD: 'JAndTExpress Dropoff',
  JWDC: 'JWD Express Chilled',
  JWDF: 'JWD Express Frozen',
  LLM: 'Lalamove',
  NJV: 'Ninja Van',
  NKS: 'Nikos Logistic',
  SCG: 'SCG Express',
  SCGC: 'SCG Express Chilled',
  SCGF: 'SCG Express Frozen',
  SEN: 'SendIt',
  SNO: 'SEINO SAHA LOGISTIC',
  THP: 'EMS',
  TP2: 'ลงทะเบียน',
  SKT: 'Skootar',
  KRY: 'Kerry',
  KRYP: 'Kerry Pickup',
  KRYD: 'Kerry Dropoff',
  BEST: 'Best Express',
  // TRUE: 'TrueELogistics',
  SPE: 'SHIPPOP Express',
  POM: 'Popman',
}

const dropoffPageQueryToCourierStateMap = {
  kryd: 'kerry',
  jntd: 'jte',
  thp_inter: 'thp_inter',
  popshop: 'popshop',
  thp: 'thp',
}

const dropoffPageCourierStateToQueryMap = {
  kerry: 'kryd',
  jte: 'jntd',
  thp_inter: 'thp_inter',
  popshop: 'popshop',
  thp: 'thp',
}

export {
  couriersCodeToNameList,
  dropoffPageQueryToCourierStateMap,
  dropoffPageCourierStateToQueryMap,
}
